import { Application } from '@feathersjs/feathers';
import { ServiceTypes } from '../../app/feathers/ServiceTypes';
import { AutoScouter } from '../../app/feathers/auto-scouter/AutoScouter';

export const resolveAutoScouter = async (
  feathers: Application<ServiceTypes>,
  electionKey: string,
  districtId: string
): Promise<AutoScouter> => {
  const result = await feathers.getService('auto-scouter').find({
    query: {
      electionKey,
      districtId,
      $sort: { updatedAt: -1, createdAt: -1 },
      $limit: 1
    }
  });

  const existing = result?.data?.[0];
  if (existing) return existing;

  return feathers.getService('auto-scouter').create({
    electionKey,
    districtId
  });
};
